// var inlineSVG = require("../../../default/js/polyfill/svg-convert.js");

// // Img svg inline
// inlineSVG.init({
//     svgSelector: 'img.svg',
//     initClass: '',
// });

// $(document).ready(function() {

//     $('#mainNavCollapse')
//         .on('show.bs.collapse', function() {
//             if (!document.body.classList.contains('menu-open')) {
//                 document.body.classList.add('menu-open')
//             }
//         })
//         .on('hidden.bs.collapse', function() {
//             if (document.body.classList.contains('menu-open')) {
//                 document.body.classList.remove('menu-open')
//             }
//         })

// });
